import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import Main from "../../../layouts/Main";
import ContentTop from "../../../ui-setup/ContentTop";
import appLabel from "../../../../config/appLabel";
import { BOM } from "../../../../services/defined.action";
import RightSide from "../../../ui-setup/RightSide";
import RecordStatus from "../../../ui-setup/RecordStatus";
import { apis as api } from "../../../../services/api.action";
import { cnt } from "../../../../services/constant.action";
import appStatic from "../../../../config/appStaticData";
import Notiflix from "notiflix";

export const AddToMenu = (props) => {
  
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const { location, history, userData } = props;
  const { state } = location;
  const { profileId, session, companyId } = userData;
  const [functionData, setFunctionData] = useState([]);
  const [currrentMenuData, setCurrrentMenuData] = useState([]);
  const [parentObj, setParentObj] = useState({});

  const [mainNameposition, setMainNameposition] = useState("");

  const [addAllResult, setAddAllResult] = useState(false);
  const [addAllText, setAddAllText] = useState("");

  const [newUserFunction, setNewUserFunction] = useState([]);
  const [readButton, setReadButton] = useState("");
  const [thirdLevel, setThirdLevel] = useState("");

  const [subMenu, setSubMenu] = useState([]);

  useEffect(() => {
    // console.log(props);

    if (!state.ggParam) {
      history.push("/manage-entity-menu");
      return;
    }
    getMenu()
    setAddAllResult(true);
    setAddAllText("Add All");
    setReadButton("Read More");

    BOM.ActivateRightBtnAction("NewItemForm", "saveBtn", formSubmit);
    // BOM.ActivateRightBtnAction("NewItemForm", "saveBtn", handleSubmit);
  }, []);

  function getMenu() {

    BOM.LoadAlert(cnt.LOAD, "Processing");

    /** FETCH MENU */
    let body = {
      profileId,
      criteria: "A",
      functionId: "",
      session,
    };
    BOM.FetchReqAction(body, api.GetMenu, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        getSpecRoleMenu(res.functionData)
      }
    });
  }

  function getSpecRoleMenu(params) {

    let getRoleMenuBody = {
      profileId,
      roleId: state.ggParam.ROLE_ID,
      session,
    };

    /** fetch (reqBody, url, svc, callback) */
    BOM.FetchReqAction(getRoleMenuBody, api.GetRoleMenu, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {

        let resultUserRole = res.roleData.FUNCTIONS;  
        addCurrentRoleToNew(resultUserRole) //this will help to add current menu
        let props = ["FUNCTION_ID", "DESCRIPTION"];

        let tempFunction = params.filter(
          function (o1) {
            // filter out (!) items in result2
            return !resultUserRole.some(
              function (o2) {
                return o1.FUNCTION_ID === o2.FUNCTION_ID; // assumes unique id
              }
            );
          }
        ).map(function (o) {
          // use reduce to make objects with only the required properties
          // and map to apply this to the filtered array as a whole
          return props.reduce(function (newo, name) {
            newo[name] = o[name];
            return o;
          }, {});
        });
        setFunctionData(tempFunction);

        if (tempFunction.length !== 0) {

          setMainNameposition(tempFunction[0].DESCRIPTION.toLowerCase());
          setParentObj(tempFunction[0]);
        }
      }
    });
  }
  /** MERGE CURRENT ROLE WITH THE NEW ONE */
  function addCurrentRoleToNew(currentArray) {

    // console.log(currentArray);
    let outerArray = [];
    let childArrMenu = [];
    let childInner = [];
    for (let index = 0; index < currentArray.length; index++) {
      const element = currentArray[index];

      for (let sub = 0; sub < element.SUB_MENU.length; sub++) {
        const subElmt = element.SUB_MENU[sub];
        // if (element.FUNCTION_ID) {
        for (const key in subElmt.CHILD_SUB_MENU) {
          const childElmt = subElmt.CHILD_SUB_MENU[key];
          childInner.push({
            functionId: childElmt.FUNCTION_ID,
            action: childElmt.ACTION,
            description: childElmt.DESCRIPTION,
          });
        }

        childArrMenu.push({
          functionId: subElmt.FUNCTION_ID,
          action: subElmt.ACTION,
          description: subElmt.DESCRIPTION,
          childMenu: childInner,
        });

        childInner = [];
        // }
      }

      outerArray.push({
        functionId: element.FUNCTION_ID,
        description: element.DESCRIPTION,
        action: "1",
        subMenu: childArrMenu, // sub array.
      });

      childArrMenu = [];
    }

    outerArray = BOM.GetUnique(outerArray, "functionId"); // sanitizing
    setNewUserFunction([...outerArray]);  
  }
  const addAll = (param) => {
    // console.log(param);
    switch (param) {
      case true:
        /** STORE CURRENT USER DATA */
        let childArrMenu = [];
        let childInner = [];
        let outerArray = [];
        for (let index = 0; index < functionData.length; index++) {
          const element = functionData[index];

          for (let sub = 0; sub < element.SUB_MENU.length; sub++) {
            const subElmt = element.SUB_MENU[sub];
            // if (element.FUNCTION_ID) {
            for (const key in subElmt.CHILD_SUB_MENU) {
              const childElmt = subElmt.CHILD_SUB_MENU[key];
              childInner.push({
                functionId: childElmt.FUNCTION_ID,
                description: childElmt.DESCRIPTION,
                action: {
                  // search: "1",
                  create: "1",
                  view: "1",
                  edit: "1",
                  approve: "1",
                  reject: "1",
                },
              });
            }

            childArrMenu.push({
              functionId: subElmt.FUNCTION_ID,
              description: subElmt.DESCRIPTION,
              childMenu: childInner,
              action: {
                // search: "1",
                create: "1",
                view: "1",
                edit: "1",
                approve: "1",
                reject: "1",
              },
            });

            childInner = [];
          }

          outerArray.push({
            functionId: element.FUNCTION_ID,
            description: element.DESCRIPTION,
            action: "1",
            subMenu: childArrMenu, // sub array.
          });

          childArrMenu = [];
        }
        outerArray = BOM.GetUnique(outerArray, "functionId");
        // console.log("Final Data: ", newUserFunction);
        setNewUserFunction([...newUserFunction, ...outerArray]);
        setAddAllResult(false);
        setAddAllText("Remove All");
        break;
      default:
        setAddAllResult(true);
        setAddAllText("Add All");
        setNewUserFunction([]);
        break;
    }
  };

  const selectedFunction = (parentData) => {
    setSubMenu(parentData.SUB_MENU);
    setParentObj(parentData);
  };

  const onAddBtn = (currentSubArray) => {
    let subTemp = [];

    currentSubArray.forEach((element) => {
      let create = $("#create" + element.FUNCTION_ID).prop("checked")
        ? "1"
        : "0";
      let view = $("#view" + element.FUNCTION_ID).prop("checked") ? "1" : "0";
      let edit = $("#edit" + element.FUNCTION_ID).prop("checked") ? "1" : "0";
      let approve = $("#approve" + element.FUNCTION_ID).prop("checked")
        ? "1"
        : "0";
      let reject = $("#reject" + element.FUNCTION_ID).prop("checked")
        ? "1"
        : "0";

      subTemp.push({
        functionId: element.FUNCTION_ID,
        description: element.DESCRIPTION,
        childMenu: [],
        action: {
          create,
          view,
          edit,
          approve,
          reject,
        },
      });
    });

    setNewUserFunction([
      ...newUserFunction,
      {
        functionId: parentObj.FUNCTION_ID,
        description: parentObj.DESCRIPTION,
        action: "1",
        subMenu: subTemp, //BOM.GetUnique(subTemp, "functionId") // sub array.
      },
    ]);

    Notiflix.Notify.success(parentObj.DESCRIPTION + " Menu was added!");
  };

  const formSubmit = (e) => {
    e.preventDefault();
    BOM.LoadAlert(cnt.LOAD, "Processing");

    let tempFunc = [...newUserFunction];
    tempFunc = BOM.GetUnique(tempFunc, "functionId"); // sanitize the final JSON

    if (newUserFunction.length === 0) {
      BOM.AlertMsg(cnt.WARNING, "Please add at least one menu before saving !");
      return;
    }

    let newSubroleMenuBody = {
      profileId,
      session,
      roleId: state.ggParam.ROLE_ID,
      functions: tempFunc,
    };

    // console.log("new Menu data ", newSubroleMenuBody);
    /** SEND REQ */
    BOM.SendReqAction(
      newSubroleMenuBody,
      api.AssignRoleMenu,
      "manage-role-menu"
    );
  };

  return (
    <Main {...props}>
      <form
        method="POST"
        id="NewItemForm"
        autoComplete="off"
        onSubmit={(e) => formSubmit(e)}
      >
        <RightSide />
        <ContentTop pageTitle={appLabel.addToMenu} />
        <div className="animated fadeInRight">
          <div className="row">
            <div className="col-lg-12">
              <div className="ibox">
                <div className="ibox-title">
                  <h5>
                    {state && state.ggParam.ROLE_NAME.length <= 25
                      ? state.ggParam.ROLE_NAME
                      : state.ggParam.ROLE_NAME + "..."}
                  </h5>
                  <div className="ibox-tools">
                    <Link
                      to="/manage-role-menu"
                      ui-sref="user-group-menu"
                      className="btn btn-primary btn-xs"
                    >
                      <i className="fa fa-arrow-circle-left" />
                      &nbsp;
                      {appLabel.backBtn}
                    </Link>

                    {functionData.length !== 0 && (
                      <a onClick={() => addAll(addAllResult)}>
                        <span
                          className={`${
                            addAllResult
                              ? "btn btn-primary btn-xs"
                              : "btn btn-danger btn-xs"
                          }`}
                        >
                          <i className="fa fa-chevron-circle-right" /> &nbsp;
                          {addAllText}
                        </span>
                      </a>
                    )}
                  </div>
                </div>
                <div className="ibox-content contentCard panel-primary">
                  {functionData.length === 0 ? (
                    <div
                      style={{ marginTop: 35, fontWeight: 'bold'}}
                      className="alert alert-success text-center"
                    >
                      {appLabel.has_all_menu_configured}
                    </div>
                  ) : (
                    <>
                      {addAllResult ? (
                        <>
                          <ul className="nav nav-tabs">
                            {functionData.map((item, index) => (
                              <li
                                className={`${
                                  item.DESCRIPTION.toLowerCase() ===
                                  mainNameposition
                                    ? "active"
                                    : ""
                                }`}
                                key={index}
                              >
                                <a
                                  data-toggle="tab"
                                  href="#tab-2"
                                  target="_self"
                                  onClick={() => selectedFunction(item)}
                                >
                                  <i
                                    className={`fa fa-${item.ICON} text-navy`}
                                  />
                                  &nbsp; {item.DESCRIPTION}
                                </a>
                              </li>
                            ))}
                          </ul>
                          <div className="tab-content">
                            <div id="tab-1" className="tab-pane active">
                              <div className="full-height-scroll">
                                <div className="table-responsive">
                                  {functionData.length === 0 ? (
                                    <div
                                    style={{ marginTop: 35, fontWeight: 'bold'}}
                                      className="alert alert-warning text-center"
                                    >
                                      {appLabel.this_menu_has_no_sub_menu}
                                    </div>
                                  ) : (
                                    <table className="table table-striped table-hover">
                                      <tbody>
                                        {functionData[0].SUB_MENU.map(
                                          (submenu, index) => (
                                            <tr key={index}>
                                              <td>
                                                <label
                                                  style={{ cursor: "pointer" }}
                                                >
                                                  &nbsp; {submenu.DESCRIPTION}
                                                </label>
                                              </td>
                                              <td>
                                                {appStatic.subActionList.map(
                                                  (item, index) => (
                                                    <label
                                                      key={index}
                                                      className="al-subtitle"
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      &nbsp; &nbsp;
                                                      <input
                                                        type="checkbox"
                                                        id={`${
                                                          item.name +
                                                          submenu.FUNCTION_ID
                                                        }`}
                                                      />
                                                      &nbsp;{" "}
                                                      {BOM.Uwfirst(item.name)}
                                                    </label>
                                                  )
                                                )}
                                              </td>
                                            </tr>
                                          )
                                        )}
                                        {
                                          <tr>
                                            <td>
                                              <a
                                                onClick={() =>
                                                  onAddBtn(
                                                    functionData[0].SUB_MENU
                                                  )
                                                }
                                              >
                                                <span className="btn btn-success">
                                                  <i className="fa fa-plus-circle" />
                                                  {/* Add */}
                                                </span>
                                              </a>
                                            </td>
                                          </tr>
                                        }
                                      </tbody>
                                    </table>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div id="tab-2" className="tab-pane">
                              <div className="full-height-scroll">
                                <div className="table-responsive">
                                  {subMenu.length === 0 ? (
                                    <div
                                    style={{ marginTop: 35, fontWeight: 'bold'}}
                                      className="alert alert-warning text-center"
                                    >
                                      {appLabel.this_menu_has_no_sub_menu}
                                    </div>
                                  ) : (
                                    <table className="table table-striped table-hover">
                                      <tbody>
                                        {subMenu.map((submenu, index) => (
                                          <tr key={index}>
                                            <td>
                                              {index + 1}{" "}
                                              <label
                                                style={{ cursor: "pointer" }}
                                              >
                                                &nbsp; {submenu.DESCRIPTION}
                                              </label>
                                            </td>
                                            {
                                              <td>
                                                {appStatic.subActionList.map(
                                                  (item, index) => (
                                                    <label
                                                      key={index}
                                                      className="al-subtitle"
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      &nbsp; &nbsp;
                                                      <input
                                                        type="checkbox"
                                                        id={`${
                                                          item.name +
                                                          submenu.FUNCTION_ID
                                                        }`}
                                                      />
                                                      &nbsp;{" "}
                                                      {BOM.Uwfirst(item.name)}
                                                    </label>
                                                  )
                                                )}
                                              </td>
                                            }
                                          </tr>
                                        ))}
                                        {
                                          <tr>
                                            <td>
                                              <a
                                                onClick={() =>
                                                  onAddBtn(subMenu)
                                                }
                                              >
                                                <span className="btn btn-success">
                                                  <i className="fa fa-plus-circle" />
                                                  {/* Add */}
                                                </span>
                                              </a>
                                            </td>
                                          </tr>
                                        }
                                      </tbody>
                                    </table>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <div
                        style={{ marginTop: 35, fontWeight: 'bold'}}
                          className="alert alert-warning text-center"
                        >
                          {appLabel.You_are_about_to_add_all_config}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <RecordStatus {...BOM.NewRecordStatusdata()} />
    </Main>
  );
}

const mapStateToProps = (state) => ({
  userData: state.auth.userData,
});
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(AddToMenu);